import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

export default function Activities({ currentUser }) {
  const [activities, setActivities] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [filter, setFilter] = useState("");
  const username = localStorage.getItem("username");


  useEffect(() => {
    async function getActivities() {
      try {
        const response = await fetch('https://fitnesstrac-kr.herokuapp.com/api/activities/', {
            headers: {
                'Content-type': 'application/json'
            }
        });
        const result = await response.json();
        console.log(result)
        setActivities(result);
        setFilteredActivities(result);
      } catch (err) {
        console.log(err);
      }
    }
    getActivities();
  }, []);

  useEffect(() => {
    setFilteredActivities(
      activities.filter((activity) => {
        return (
            activity.name.toLowerCase().includes(filter.toLowerCase()) ||
            activity.description.toLowerCase().includes(filter.toLowerCase())
        );
      })
    );
  }, [filter, activities]);


  return (
    <div className="activities-container">
      <div className="activities-header">
        <h1>Activities</h1>
        <div className="activities-filter">
          <input
            type="filter-text"
            placeholder="Filter activities"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <Link to="/Activities/Add">
            <button className="add-activity-btn">Add an Activity</button>
          </Link>
        </div>
      </div>
      {filteredActivities.map((activity) => {
        return (
          <div key={activity.id} className="card">
            <h2>{activity.name}</h2>
            <div>{activity.description}</div>
            <Link
            //  to="/Activities/Edit"
             >
                <button>Edit Activity (currently disabled)</button>
            </Link>
          </div>
        );
      })}
    </div>
  );
}